export const AsyncStorageKeys = {
  codeApplied: "codeApplied",
};
